module.exports = __webpack_public_path__ + "img/court-1.15f6dd93.png";